var _defs, _path, _g, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlphaInsightsSecondaryLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 356.77 204.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M262.81,26.88c-1.25-2.37-3.71-3.85-6.39-3.85h-34.18c-2.68,0-5.13,1.48-6.39,3.85l-86.69,163.88c-1.18,2.24-1.11,4.93.2,7.1,1.31,2.17,3.66,3.5,6.19,3.5h29.71c2.71,0,5.18-1.51,6.42-3.92l16.87-32.75h101.57l16.87,32.75c1.24,2.4,3.72,3.92,6.42,3.92h29.71c2.53,0,4.88-1.33,6.19-3.5,1.31-2.17,1.38-4.87.2-7.1L262.81,26.88ZM269.37,125.8h-60.02l30.19-56.73,29.82,56.73Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.41,
    y: 141.72,
    width: 19.85,
    height: 59.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 51.06,
    y: 106.59,
    width: 19.85,
    height: 94.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 90.7,
    y: 85.12,
    width: 19.86,
    height: 116.08
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "128.6 52.59 128.6 161.15 148.45 123.62 148.45 52.59 128.6 52.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "186.35 23.3 166.5 23.3 166.5 89.5 186.35 51.97 186.35 23.3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.17,5.18c.19-1.38-.99-2.57-2.38-2.38l-24.61,3.37-.89.12c-1.73.24-2.44,2.35-1.21,3.58l.02.02,7.88,7.88-43.57,45.13-16.89-7.93L7.73,110.77c-1.79,1.86-1.73,4.81.12,6.6.9.87,2.07,1.31,3.24,1.31,1.22,0,2.44-.48,3.36-1.43l49.15-50.99,16.89,7.93,48.09-49.81,7.51,7.51c1.23,1.23,3.35.52,3.58-1.21l.12-.89,3.37-24.61Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlphaInsightsSecondaryLogoWhite);
export default __webpack_public_path__ + "static/media/Alpha Insights Secondary Logo-White.989e9f764cf6c1707ec143b3b748419d.svg";
export { ForwardRef as ReactComponent };